import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Words from "./Words";

function WordsContainer(props) {
  return (
    <Col>
      <Row>
        <div style={{ textAlign: "center", fontSize: "60px" }}>
          {props.words.map((word) => (
            <Words key={word.id} id={word.id} name={word.word} />
          ))}
        </div>
      </Row>
    </Col>
  );
}

export default WordsContainer;
